import { makeStyles } from 'tss-react/mui';

export default makeStyles()(theme => ({
    btnPayment: {
        width: '100%'
    }
}));